import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";

export function TermsLink({ children, testid = "terms-link" }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button type="button" data-testid={testid} className="text-[#DC2626] hover:underline">{children}</button>
      </DialogTrigger>
      <DialogContent className="bg-[#180D0D] border-zinc-800 text-white max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Terms & Community Guidelines</DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[60vh] pr-3">
          <div className="space-y-4 text-sm text-zinc-300 leading-relaxed">
            <section>
              <h3 className="font-semibold text-white mb-1">1. Who can use NextScene</h3>
              <p>NextScene is a stage for real talent from every corner of India. You must be at least 13 years old. Users under 18 need a parent or guardian's acknowledgment at signup.</p>
            </section>
            <section>
              <h3 className="font-semibold text-white mb-1">2. Your content</h3>
              <p>You own the videos you upload. By posting, you give NextScene a licence to display, promote and share your content on and off the platform (with credit). You confirm the content is yours and does not violate anyone's rights.</p>
            </section>
            <section>
              <h3 className="font-semibold text-white mb-1">3. Community rules</h3>
              <ul className="list-disc ml-5 space-y-1">
                <li>No hate speech, harassment, threats, or targeted abuse.</li>
                <li>No nudity, sexual content, graphic violence or self-harm content.</li>
                <li>No impersonation. Use your real name and a real photo.</li>
                <li>No spam, fake engagement, or misleading claims of casting.</li>
                <li>Respect fellow creators — Challenge This is about craft, not takedowns.</li>
              </ul>
            </section>
            <section>
              <h3 className="font-semibold text-white mb-1">4. Reports & moderation</h3>
              <p>Any video or profile that receives 10 or more reports is automatically hidden pending admin review. Repeat violations may result in account suspension.</p>
            </section>
            <section>
              <h3 className="font-semibold text-white mb-1">5. Plans, payments & refunds</h3>
              <p>Plus, Pro and Verified Badge payments are processed via Razorpay. Plans auto-renew monthly. Refunds are handled on a case-by-case basis within 7 days of purchase — contact support.</p>
            </section>
            <section>
              <h3 className="font-semibold text-white mb-1">6. Casting opportunities</h3>
              <p>Roles are posted by verified casting directors. NextScene is a bridge — the actual hiring, payment and contracting is between you and the caster.</p>
            </section>
            <section>
              <h3 className="font-semibold text-white mb-1">7. Privacy</h3>
              <p>We collect your email, name, DOB, city, phone (optional) and content you upload. We do not sell your data. Contact info is shown to matched casting directors only.</p>
            </section>
            <section>
              <h3 className="font-semibold text-white mb-1">8. Changes</h3>
              <p>We may update these terms as the platform evolves. Continued use after changes means you accept them.</p>
            </section>
            <p className="text-xs text-zinc-400 pt-2 border-t border-zinc-800">Questions? Reach out at hello@nextscene.in</p>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
